import React, { useMemo } from "react";
import { Table } from "antd";
import IssueTitleCell from "../../components/Issue/IssueTitleCell";
import CreatedAssignedCell from "../../components/Issue/CreatedAssignedCell";
import DurationCell from "../../components/Issue/DurationCell";
import DueProgress from "../../components/Progress/DueProgress";
import EstimateProgress from "../../components/Progress/EstimateProgress";
import ErrorState from "../../components/ErrorState/ErrorState";
import EmptyState from "../../components/EmptyState/EmptyState";
const getEstimatePercent = (record) => {
  if (!record.timeEstimate || record.timeEstimate <= 0) return 0;
  return Math.min(
    ((record.totalTimeSpent || 0) / record.timeEstimate) * 100,
    100
  );
};

const IssueTable = ({ issues, hasError, errorMessage, username }) => {
  const columns = useMemo(
    () => [
      {
        title: "Issue",
        dataIndex: "title",
        key: "title",
        width: "32%",
        sorter: (a, b) => (a.title || "").localeCompare(b.title || ""),
        render: (_, record) => <IssueTitleCell record={record} />,
      },
      {
        title: "Created & Assigned",
        key: "created_assigned",
        width: "18%",
        sorter: (a, b) => (a.created_at || 0) - (b.created_at || 0),
        render: (_, record) => <CreatedAssignedCell record={record} />,
      },
      {
        title: "Due Date",
        dataIndex: "dueDate",
        key: "dueDate",
        width: "14%",
        align: "center",
        sorter: (a, b) => (a.dueDate || 0) - (b.dueDate || 0),
        render: (_, record) => (
          <DueProgress
            dueDate={record.dueDate}
            assignEpoch={record.assign_epoch}
          />
        ),
      },
      {
        title: "Estimate",
        dataIndex: "timeEstimate",
        key: "timeEstimate",
        width: "10%",
        align: "center",
        sorter: (a, b) => (a.timeEstimate || 0) - (b.timeEstimate || 0),
        render: (value) => <DurationCell seconds={value} />,
      },
      {
        title: "Spent",
        dataIndex: "totalTimeSpent",
        key: "totalTimeSpent",
        width: "10%",
        align: "center",
        sorter: (a, b) => (a.totalTimeSpent || 0) - (b.totalTimeSpent || 0),
        render: (value) => <DurationCell seconds={value} />,
      },
      {
        title: "Exceeded",
        dataIndex: "exceeded_time",
        key: "exceeded_time",
        width: "10%",
        align: "center",
        sorter: (a, b) => (a.exceeded_time || 0) - (b.exceeded_time || 0),
        render: (value) => <DurationCell seconds={value} isExceeded />,
      },
      {
        title: "Progress",
        key: "progress",
        width: "16%",
        align: "center",
        sorter: (a, b) => getEstimatePercent(a) - getEstimatePercent(b),
        render: (_, record) => (
          <EstimateProgress
            timeEstimate={record.timeEstimate}
            totalTimeSpent={record.totalTimeSpent}
          />
        ),
      },
    ],
    []
  );

  const locale = {
    emptyText: hasError ? (
      <ErrorState
        message={errorMessage || `Failed to load issues for ${username}`}
      />
    ) : (
      <EmptyState />
    ),
  };

  return (
    <Table
      columns={columns}
      dataSource={issues}
      pagination={false}
      size="small"
      scroll={{ x: "max-content" }}
      locale={locale}
      rowKey="key"
      className="issue-table"
    />
  );
};

export default IssueTable;
